var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9988 6.00036V12.0004M20.4188 6.92236C20.5978 6.84338 20.7498 6.71363 20.8558 6.54916C20.9617 6.3847 21.0172 6.19275 21.0151 5.99709C21.0131 5.80144 20.9537 5.61068 20.8444 5.44844C20.735 5.2862 20.5804 5.15961 20.3998 5.08436L11.8288 1.18036C11.5683 1.06151 11.2852 1 10.9988 1C10.7124 1 10.4294 1.06151 10.1688 1.18036L1.59882 5.08036C1.42079 5.15833 1.26934 5.28649 1.16299 5.44917C1.05664 5.61185 1 5.802 1 5.99636C1 6.19072 1.05664 6.38086 1.16299 6.54354C1.26934 6.70622 1.42079 6.83438 1.59882 6.91236L10.1688 10.8204C10.4294 10.9392 10.7124 11.0007 10.9988 11.0007C11.2852 11.0007 11.5683 10.9392 11.8288 10.8204L20.4188 6.92236Z",
    stroke: "#8B909A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99878 8.5V12C4.99878 12.7956 5.63092 13.5587 6.75614 14.1213C7.88136 14.6839 9.40748 15 10.9988 15C12.5901 15 14.1162 14.6839 15.2414 14.1213C16.3666 13.5587 16.9988 12.7956 16.9988 12V8.5",
    stroke: "#8B909A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrades);
export default __webpack_public_path__ + "static/media/Grades.b67f1b29e991b52cc1817b0f8a7e0d56.svg";
export { ForwardRef as ReactComponent };